<ig-accordion 
  *ngIf="frontendSettings$ | async as settings" 
  #accordion 
  [mode]="mode" 
  [title]="title"
  class="fav-event-filter" 
  (onIconClicked)="clear()"
  role="region"
  [attr.aria-label]="'Event categories filter: ' + title">
  
  <ng-container expand *ngIf="mode==='expand'" role="menu">
    <ng-container *ngTemplateOutlet="favCustomBtns">
    </ng-container>
  </ng-container>

  <ng-container dropdown *ngIf="mode==='dropdown'" role="menu">
    <ng-container *ngTemplateOutlet="favCustomBtns">
    </ng-container>
  </ng-container>

  <ng-template #favCustomBtns>
    <button 
      mat-menu-item 
      (click)="gotoCategory()"
      (keydown.enter)="gotoCategory()"
      (keydown.space)="gotoCategory(); $event.preventDefault()"
      role="menuitemradio"
      [attr.aria-checked]="!selectedFilterId"
      [attr.aria-label]="'Show all events' + (title === 'ALL' ? ' (selected)' : '')">
      ALL
    </button>
    
    <button 
      *ngIf="!settings.customSettings.isHideEditorChoice" 
      mat-menu-item
      (click)="gotoEditorChoice(settings.customSettings.customEditorChoice.editorChoiceForEvent)"
      (keydown.enter)="gotoEditorChoice(settings.customSettings.customEditorChoice.editorChoiceForEvent)"
      (keydown.space)="gotoEditorChoice(settings.customSettings.customEditorChoice.editorChoiceForEvent); $event.preventDefault()"
      class="!flex flex-row-reverse !justify-end items-center choice-btn"
      [class.btn-selected]="title===settings.customSettings.customEditorChoice.editorChoiceForEvent"
      role="menuitemradio"
      [attr.aria-checked]="title===settings.customSettings.customEditorChoice.editorChoiceForEvent"
      [attr.aria-label]="settings.customSettings.customEditorChoice.editorChoiceForEvent + (title === settings.customSettings.customEditorChoice.editorChoiceForEvent ? ' (selected)' : '')">
      {{settings.customSettings.customEditorChoice.editorChoiceForEvent}}
      <mat-icon 
        class="ml-3 !text-red-400" 
        aria-hidden="true">favorite</mat-icon>
    </button>
    
    <button 
      *ngFor="let btn of settings.customSettings.customEvents" 
      mat-menu-item 
      (click)="gotoCategory(btn)"
      (keydown.enter)="gotoCategory(btn)"
      (keydown.space)="gotoCategory(btn); $event.preventDefault()"
      [class.btn-selected]="title===btn.btnText"
      role="menuitemradio"
      [attr.aria-checked]="title===btn.btnText"
      [attr.aria-label]="btn.btnText + (title === btn.btnText ? ' (selected)' : '')">
      {{btn.btnText}}
    </button>
  </ng-template>
</ig-accordion>